/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Hours_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Hours (hh)" |
*
* @param {Subtitle_Export_Hours_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_hours_placeholder = /** @type {((inputs?: Subtitle_Export_Hours_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Hours_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heures (hh)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stunden (hh)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ore (hh)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Часы (чч)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Horas (hh)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("小时 (hh)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時間（hh）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घंटे (hh)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Horas (hh)")
	return /** @type {LocalizedString} */ ("Hours (hh)")
});